__turbopack_context__.v({
  "advancedSearchIcon": "searchBar-module-scss-module__QunIFW__advancedSearchIcon",
  "buttonContainer": "searchBar-module-scss-module__QunIFW__buttonContainer",
  "desktopMenu": "searchBar-module-scss-module__QunIFW__desktopMenu",
  "discordIcon": "searchBar-module-scss-module__QunIFW__discordIcon",
  "homepageInput": "searchBar-module-scss-module__QunIFW__homepageInput",
  "linkIcon": "searchBar-module-scss-module__QunIFW__linkIcon",
  "mainSearchInput": "searchBar-module-scss-module__QunIFW__mainSearchInput",
  "mainSearchInputContainer": "searchBar-module-scss-module__QunIFW__mainSearchInputContainer",
  "menuIcon": "searchBar-module-scss-module__QunIFW__menuIcon",
  "menuLink": "searchBar-module-scss-module__QunIFW__menuLink",
  "mobileMenuButton": "searchBar-module-scss-module__QunIFW__mobileMenuButton",
  "navInput": "searchBar-module-scss-module__QunIFW__navInput",
  "outerContainer": "searchBar-module-scss-module__QunIFW__outerContainer",
  "profileIcon": "searchBar-module-scss-module__QunIFW__profileIcon",
  "randomIcon": "searchBar-module-scss-module__QunIFW__randomIcon",
  "searchInputIcon": "searchBar-module-scss-module__QunIFW__searchInputIcon",
  "syntaxGuideIcon": "searchBar-module-scss-module__QunIFW__syntaxGuideIcon",
});
